module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Ka-La.010b305d.png";